import {
  isRejected,
  isRejectedWithValue,
  type Middleware,
  type MiddlewareAPI,
} from '@reduxjs/toolkit';
import {
  openCannotChangeCurrentResourceNotify_405,
  openServerErrorNotify_500,
} from '@shared/hooks/use-error-handler.ts';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action: any) => {
  if (isRejectedWithValue(action)) {
    // если запрос не прошёл по причине отсутствия интернета
    if (action.payload.status === 'FETCH_ERROR') {
      console.log('Хватит баловаться с вкладкой Network, включи интернет :)');

      // если поступает запрос от пользователя, не имеющего токена
    } else if (action.payload.status === 401) {
      localStorage.removeItem('token');
      window.location.reload();
      window.location.replace(window.location.origin);
    }
  }

  if (isRejected(action)) {
    // if (action.payload?.status === 400 || action.payload?.originalStatus === 400) {
    //   api.dispatch(openClientErrorNotify_400());
    // }
    if (action.payload?.status === 405 || action.payload?.originalStatus === 405) {
      api.dispatch(openCannotChangeCurrentResourceNotify_405());
    }
    if (action.payload?.status === 500 || action.payload?.originalStatus === 500) {
      api.dispatch(openServerErrorNotify_500());
    }
    if (action.payload?.status === 502 || action.payload?.originalStatus === 502) {
      // console.log('технические работы');
      if (window.location.href.search('technical-service') === -1) {
        return (window.location.href = '/technical-service');
      }
    }
  }
  return next(action);
};
